const money = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export const formatMoney = value => money.format(Number(value) || 0);

// value for <input type="datetime-local"> in the browser's time zone
export const toLocalInput = date => {
	const pad = n => String(n).padStart(2, "0");
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
		date.getHours()
	)}:${pad(date.getMinutes())}`;
};

export const formatDue = value =>
	value
		? new Date(value).toLocaleString([], { dateStyle: "short", timeStyle: "short" })
		: "";
